module.exports = __webpack_public_path__ + "img/info-2.176cba14.png";